import { Link } from "gatsby"
import React from "react"

export const DropdownMenuItemsMobile = ({ dropdown_menu_items, page }) => {
  const isPartiallyActiveSubmenuTouchDropdown = ({ isPartiallyCurrent }) => ({
    className: `submenu-dropdown-touch-item${isPartiallyCurrent ? "-active" : ""}`,
  })

  return (
    <React.Fragment>
      {dropdown_menu_items.map(({ link, label }, index) => {
        return (
          <Link
            getProps={isPartiallyActiveSubmenuTouchDropdown}
            key={`dropdown-touch-linkitem-${page}-${index}`}
            to={link}
          >
            {label}
          </Link>
        )
      })}
    </React.Fragment>
  )
}
